import styled from 'styled-components';
import BestRatesNewSvg from '../../../assets/onboardingNew/homepage/best-rates.svg';

const BestRatesNewIcon = styled(BestRatesNewSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.6rem'};
height: ${props => props.height || '3.6rem'};
display: flex;
`;

export default BestRatesNewIcon;
